import {
  faMusic,
  faCode,
  faHouse,
  faFileLines,
  faHeartPulse,
  faDumbbell,
  faBookOpen,
  faPen,
  faFeather,
  faPalette,
  faPeopleRoof,
  faUserGroup,
  faUtensils,
  faCartShopping,
  faCar,
  faCoins,
  faDesktop,
  faGlobe,
  faMobileScreen,
  faLeaf,
  faTag,
  faGraduationCap,
  faLandmark,
  faWineGlass,
  faThumbsDown 
} from "@fortawesome/free-solid-svg-icons";

export const themeIcons = {
  music: faMusic,
  code: faCode,
  house: faHouse,
  "file-lines": faFileLines,
  "heart-pulse": faHeartPulse,
  dumbbell: faDumbbell,
  "book-open": faBookOpen,
  pen: faPen,
  feather: faFeather,
  palette: faPalette,
  "people-roof": faPeopleRoof,
  "user-group": faUserGroup,
  utensils: faUtensils,
  "cart-shopping": faCartShopping,
  car: faCar,
  coins: faCoins,
  desktop: faDesktop,
  globe: faGlobe,
  "mobile-screen": faMobileScreen,
  leaf: faLeaf,
  tag: faTag,
  cours: faGraduationCap,
  landmark: faLandmark,
  "wine-glass": faWineGlass,
  annule: faThumbsDown
};